tarteaucitron.init({
	"privacyUrl": "/politique-de-confidentialite",
	"bodyPosition": "bottom",
	
	"hashtag": "#tarteaucitron",
	"cookieName": "tarteaucitron",
	
	"orientation": "bottom",
	
	"groupServices": false,
	"showDetailsOnClick": true,
	"serviceDefaultState": "wait",
	
	"showAlertSmall": false,
	"cookieslist": false,
	"cookieslistEmbed": false,
	
	"showIcon": false,
	
	"adblocker": false,
	
	"DenyAllCta" : true,
	"AcceptAllCta" : true,
	"highPrivacy": true,
	"alwaysNeedConsent": false,
	
	"handleBrowserDNTRequest": false,
	
	"removeCredit": true,
	"moreInfoLink": true,
	"useExternalCss": true,
	"useExternalJs": false,
	
	"readmoreLink": "",
	
	"mandatory": true,
	"mandatoryCta": true,
		
	"googleConsentMode": true,
	"bingConsentMode": true,
	"softConsentMode": false,
	
	"dataLayer": false,
	"serverSide": false,
	
	"partnersList": false
  });
  tarteaucitron.user.googletagmanagerId = 'GTM-5GKP7SRW';
  (tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
  (tarteaucitron.job = tarteaucitron.job || []).push('gcmanalyticsstorage');